export const START = 'START';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';
